var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRfxGeneratorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66671 1.66675H3.00004C2.55801 1.66675 2.13409 1.84234 1.82153 2.1549C1.50897 2.46746 1.33337 2.89139 1.33337 3.33341V16.6667C1.33337 17.1088 1.50897 17.5327 1.82153 17.8453C2.13409 18.1578 2.55801 18.3334 3.00004 18.3334H13C13.4421 18.3334 13.866 18.1578 14.1786 17.8453C14.4911 17.5327 14.6667 17.1088 14.6667 16.6667V6.66675M9.66671 1.66675L14.6667 6.66675M9.66671 1.66675L9.66671 6.66675H14.6667M8.00004 15.0001V10.0001M5.50004 12.5001H10.5",
    stroke: "#3474E0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfxGeneratorIcon);
export default __webpack_public_path__ + "static/media/rfx_generator_icon.d0b3156edd2e6b1853b620105633a415.svg";
export { ForwardRef as ReactComponent };